import {createReducer, on} from '@ngrx/store';
import {SendenDialogState} from '../states/senden-dialog.state';
import {SendenDialogActions} from '../actions/senden-dialog.actions';


export const initialSendenDialogState: SendenDialogState = {
  isOpen: false,
  vorschauBetreff: null,
  vorschauBody: null,
  vorschauLoading: false,
  vorschauError: null,
  sending: false,
  empfaengerZuletztUnzustellbar: false,
};

export const sendenDialogReducer = createReducer(
  initialSendenDialogState,

  on(
    SendenDialogActions.open,
    (state, {betriebId, belegId, belegnummer, belegart, empfaengerEmail}) => ({
      ...state,
      isOpen: true,
      betriebId,
      belegId,
      belegnummer,
      belegart,
      empfaengerEmail,
      vorschauBetreff: null,
      vorschauBody: null,
      vorschauLoading: false,
      vorschauError: null,
      sending: false,
      empfaengerZuletztUnzustellbar: false,
    })
  ),

  on(
    SendenDialogActions.close,
    () => ({
      ...initialSendenDialogState,
    })
  ),

  on(
    SendenDialogActions.loadVorschau,
    (state) => ({
      ...state,
      vorschauLoading: true,
      vorschauError: null,
    })
  ),

  on(
    SendenDialogActions.loadVorschauSuccess,
    (state, {betreff, body}) => ({
      ...state,
      vorschauBetreff: betreff,
      vorschauBody: body,
      vorschauLoading: false,
      vorschauError: null,
    })
  ),

  on(
    SendenDialogActions.loadVorschauFailure,
    (state, {error}) => {
      // INFO: Frontend-baut den Discriminator aus dem HTTP-Status selbst —
      // bewusst KEIN Backend-Free-Text (z.B. ProblemDTO.title). Damit ist
      // garantiert kein vom Backend gestellter String im NgRx-State.
      // Falls UI fehlerklassen-spezifische Texte braucht, geschieht das
      // anhand dieses status-basierten Codes im Component.
      const status = error.status ?? 0;
      return {
        ...state,
        vorschauBetreff: null,
        vorschauBody: null,
        vorschauLoading: false,
        vorschauError: {
          status,
          code: status > 0 ? `http_${status}` : undefined,
        },
      };
    }
  ),

  on(
    SendenDialogActions.versendeBeleg,
    (state) => ({
      ...state,
      sending: true,
    })
  ),

  on(
    SendenDialogActions.versendeBelegSucceeded,
    (state) => ({
      ...state,
      sending: false,
    })
  ),

  on(
    SendenDialogActions.versendeBelegFailed,
    (state) => ({
      ...state,
      sending: false,
    })
  ),

  on(
    SendenDialogActions.pruefeZustellbarkeit,
    SendenDialogActions.pruefeZustellbarkeitFailure,
    SendenDialogActions.resetZustellbarkeit,
    (state) => ({
      ...state,
      empfaengerZuletztUnzustellbar: false,
    })
  ),

  on(
    SendenDialogActions.pruefeZustellbarkeitSuccess,
    (state, {zuletztUnzustellbar}) => ({
      ...state,
      empfaengerZuletztUnzustellbar: zuletztUnzustellbar,
    })
  ),
);
